import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/crm/Login";
import Dashboard from "@/pages/crm/Dashboard";
import Pipeline from "@/pages/crm/Pipeline";
import LeadsList from "@/pages/crm/LeadsList";
import Schedule from "@/pages/crm/Schedule";
import Team from "@/pages/crm/Team";
import Attribution from "@/pages/crm/Attribution";
import ProtectedRoute from "@/components/crm/ProtectedRoute";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/crm/login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/crm" element={<Dashboard />} />
            <Route path="/crm/pipeline" element={<Pipeline />} />
            <Route path="/crm/leads" element={<LeadsList />} />
            <Route path="/crm/schedule" element={<Schedule />} />
            <Route path="/crm/team" element={<Team />} />
            <Route path="/crm/attribution" element={<Attribution />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
